<template>
  <div class="RegisterSpams">
    <spasms-add-button ref="addSpasm" @click="registerSpasm"/>
    <br/>
    <v-combobox
      @update:search-input="updateContext"
      v-model="context"
      :items="contexts"
      label="O que aconteceu?"
      outlined
      dense
      hint="ex: comendo, acordando, assustou-se"
      persistent-hint
      :cache-items="true"
    ></v-combobox>

    <div v-if="spasmTypes.length > 0" class="mt-4">
      <div class="text-caption grey--text mb-1">Tipo de Crise</div>
      <v-chip-group
        v-model="selectedTypeIndex"
        active-class="primary white--text"
        column
      >
        <v-chip
          v-for="type in spasmTypes"
          :key="type.id"
          filter
        >
          {{ type.name }}
        </v-chip>
      </v-chip-group>
    </div>
    <div v-else class="text-caption grey--text mt-2">
      Nenhum tipo de crise cadastrado. <router-link to="/spasm-types">Cadastrar tipos</router-link>
    </div>

    <div class="RegisterSpamsMessage text-center mt-2">{{message}}</div>
  </div>
</template>
<script>
import SpasmService from '../../lib/spasms-control/SpasmService'
import { getToken } from '../../utils'
import SpasmsAddButton from '../small/SpasmsAddButton.vue'
import store from '../../store'

export default {
  name: 'RegisterSpasm',
  components: { SpasmsAddButton },
  props: {
    dependentId: {
      type: Number,
      required: true
    },
    happenedAt: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      message: '',
      context: '',
      contexts: [],
      spasmTypes: [],
      selectedTypeIndex: null
    }
  },
  methods: {
    spasmDateTime: function () {
      let spasmDateTime = new Date()
      if (this.happenedAt) {
        spasmDateTime = new Date(this.happenedAt)
      }
      return spasmDateTime
    },
    updateContext: function (event) {
      this.context = event
      this.$ga.event('userInteraction', 'update', 'btn', 'registerSpasm')
    },
    loadSpasmTypes: function () {
      const authToken = getToken()
      const service = new SpasmService(authToken)
      service.getSpasmTypes(this.dependentId).then(response => {
        this.spasmTypes = response.data
      })
    },
    registerSpasm: async function () {
      this.$ga.event('userInteraction', 'click', 'btn', 'registerSpasm')
      this.$refs.addSpasm.loading = true

      const authToken = getToken()
      const service = new SpasmService(authToken)
      
      let spasmTypeId = null
      if (this.selectedTypeIndex !== null && this.selectedTypeIndex !== undefined) {
        spasmTypeId = this.spasmTypes[this.selectedTypeIndex].id
      }

      const data = {
        happenedAt: this.spasmDateTime().toJSON(),
        dependentId: this.dependentId,
        context: this.context,
        spasm_type: spasmTypeId
      }
      if (this.context) {
        this.contexts.push(this.context)
        store.addContextAction(this.context)
      }
      service.create(data)
      .then(data => {
        this.context = ''
        this.selectedTypeIndex = null
        if (data.id) {
          this.message = 'Espasmo registrado: ' + this.spasmDateTime().toLocaleString()
          this.$emit('spasmRegistered', data)
        } else {
          this.message = 'Algo deu errado!'
        }
        this.$refs.addSpasm.loading = false
      })
      .catch(error => {
        this.$emit('spasmRegistered', error)
        this.$refs.addSpasm.loading = false
      })
    },
  },
  created: function () {
    this.contexts = this.$root.$data.sharedState.contextsItens
    this.loadSpasmTypes()
  }
}
</script>
